// extracted by mini-css-extract-plugin
export default {"reset_button":"styles-module__reset_button--Z_15R"};